import PropTypes from 'prop-types';
import { fromJS } from 'immutable';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import { Checkbox, List, ListItem, ListItemText, Grid, TextField } from '@material-ui/core';

import SelectableChip from 'retired/SelectableChip';

const UnsetButton = ({ onChange }) => (
  <SelectableChip onClick={() => onChange()} label="Unset" style={{ margin: 0 }} />
);
UnsetButton.propTypes = { onChange: PropTypes.object };

const FormEntitySelector = ({ fields, fetchOptions, deedTypes, beforeList, meta: { error } }) => {
  const [options, setOptions] = useState(fromJS([]));
  const value = fields.getAll();
  const updateOptions = _.debounce(
    (searchTerm) =>
      fetchOptions(searchTerm, searchTerm ? undefined : value, deedTypes).subscribe((o) =>
        setOptions(fromJS(o))
      ),
    600
  );
  useEffect(() => {
    updateOptions();
  }, []);
  return (
    <div>
      <Grid container justifyContent="space-between" style={{ marginTop: 15, marginBottom: 10 }}>
        <Grid item style={{ width: '80%' }}>
          <TextField
            placeholder="Search by name..."
            onChange={(e) => updateOptions(e.target.value)}
            style={{ width: '100%' }}
          />
        </Grid>
        <Grid item>
          <SelectableChip onClick={() => fields.removeAll()} label="Unset" style={{ margin: 0 }} />
        </Grid>
      </Grid>
      <List style={{ maxHeight: 300, overflow: 'auto' }}>
        {beforeList}
        {options
          .map((option) => {
            const selected = !!(value && value.includes(option.get('id')));
            const onClick = () => {
              if (selected) {
                fields.remove(value.indexOf(option.get('id')));
              } else {
                fields.push(option.get('id'));
              }
            };
            return (
              <ListItem button onClick={onClick} key={option.get('id')}>
                <Checkbox color="primary" checked={selected} tabIndex={-1} />
                <ListItemText primary={option.get('name')} />
              </ListItem>
            );
          })
          .toArray()}
      </List>
      {error && (
        <FormLabel error style={{ fontSize: 12, marginTop: 5 }}>
          {error}
        </FormLabel>
      )}
    </div>
  );
};
FormEntitySelector.propTypes = {
  fetchOptions: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  beforeList: PropTypes.object,
  deedTypes: PropTypes.array,
};
export default FormEntitySelector;
